import { BOT_WAIT_LOADER, BUTTON_LOADER, BOT_WAIT_LOADER_WITH_SHIMMER, SEARCH_LOADER, SET_LOADER } from "../constants";

export const setBotWaitLoader = (data) => (dispatch) => {
	dispatch({
		type: BOT_WAIT_LOADER,
		data: data,
	});
};

export const setBotWaitLoaderWithShimmer = (data) => (dispatch) => {
	dispatch({
		type: BOT_WAIT_LOADER_WITH_SHIMMER,
		data: data,
	});
};

export const setSearchLoader = (isLoading) => ({
	type: SEARCH_LOADER,
	payload: isLoading,
});


export const setButtonLoader = (isLoading) => ({
	type: BUTTON_LOADER,
	payload: isLoading,
});


export const setLoader = (isLoading) => ({
	type: SET_LOADER,
	payload: isLoading,
});